import { gql } from '@apollo/client';
import { WAREHOUSE_FIELDS, WarehouseType } from '../types/WarehouseType';

/**
 * 获取当前用户可访问的所有Hub和Warehouse
 * 这是一个统一的接口，替代了原来分散在各个模块中的不同查询
 * 不需要参数，后端会根据当前用户角色自动返回对应的仓库数据
 */
export const GET_ALL_ACCESS_HUB_AND_WAREHOUSES_FOR_ROLE = gql`
    query GetAllAccessHubAndWarehousesForRole {
        warehouses: getAllAccessHubAndWarehousesForRole {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export interface GetAllAccessHubAndWarehousesForRoleResponse {
    warehouses: Array<Omit<WarehouseType, 'id' | 'parentSiteId'> & {
        id: string;
        parentSiteId?: string;
        siteType: number;
        companyName?: string;
        address?: string;
        phone?: string;
        email?: string;
        status: number;
        createdAt: string;
        updatedAt: string;
    }>;
}